export default {
  currentUser: {},
};
